<template>
  <div class="form-check">
    <input
      :id="id"
      class="form-check-input mt-0"
      type="radio"
      :name="name"
      :value="$attrs.value"
      :checked="modelValue === $attrs.value"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="isDisabled"
    />
    <label class="custom-control-label" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialRadio",
  props: {
    name: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Number
    },
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
};
</script>
<style scoped>
.option-item-radio .form-check-input:disabled {
  opacity: 1 !important;
}
</style>
